import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "simpleDateFormat" })
export class SimpleDateFormatPipe implements PipeTransform {
  transform(value: string): string {
    let ar: Array<string> = [];
    let dt: Date;

    if (typeof value === "undefined" || value === null) {
      return "N/A";
    }
    dt = new Date(value);
    ar = dt.toISOString().substr(0, 10).split("-");
    let year: number = Number(ar[0]);
    let month: number = Number(ar[1]);
    let day: number = Number(ar[2]);

    return month + "/" + day + "/" + year;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/simple-date-format.pipe.ts